<template>
    <div class="container">
        <van-nav-bar
            title="车辆订单统计"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="container">
            <div class="header">
                <div class="selele-date df">
                    <van-dropdown-menu class="norm" active-color="#1989fa">
                        <van-dropdown-item :value="selectType" @change="onSelectTypeChange"
                                           :options="selectTypeOptions"/>
                    </van-dropdown-menu>
                    <div @click="show = true">
                        {{formatedDate}}
                    </div>
                </div>
                <div class="order-total">
                    <div class="df jcsb">
                        <span>总笔数: {{ order.order_count }}笔</span>
                        <span>总金额: {{ order.order_amount }}元</span>
                    </div>
                    <!-- <div div class="df jcsb">
                        <span>微信订单数: {{order.wxpay_order_count}}笔</span>
                        <span>支付宝订单数: {{order.alipay_order_count}}笔</span>
                    </div> -->
                </div>
            </div>
            <div class="order-list">
                <div class="order df" v-for="item in order.order_list">
                    <div class="order-title">
                        <img class="ico" src="@/assets/qiandai.png"></img>
                        <div class="pdl10">
                            <div class="fs16">车牌号:{{ item.bus.bus_number_plate }}</div>
                            <div class="fs14 pdt5">订单数: {{ item.order_total }}
                               共计:{{ item.amount_total }}元
                            </div>
                        </div>
                    </div>
                    <div class="order-amount">
                        +{{ item.amount_total }}
                    </div>
                </div>
            </div>
            <van-divider v-if="isBottom" contentPosition="center">宝宝也是有底线的</van-divider>

            <van-popup v-model="show" @close="show = false" position="bottom">
            <van-datetime-picker     v-model="defaultDate"
                                     :type="selectType == 1 ? 'date' : 'year-month'"
                                 @cancel="show = false" @confirm="onInput" :min-date="minDate"
                                 :max-date="maxDate"/>
            </van-popup>

        </div>
        <van-overlay style=" padding-top: 100px;" class="loading-container" :show="loading" @click="loading = false">
            <van-loading size="36px" vertical>加载中...</van-loading>

        </van-overlay>
    </div>
</template>

<script>
var formatNumber = function(n) {
    n = n.toString()
    return n[1] ? n : "0" + n
}
export default {
    name: "BusTotal",
    data(){
        return {
            loading: false,
            show: false,
            minDate: new Date(2025, 0, 1),
            maxDate: new Date(),
            // currentDate: 1652716800000,
            defaultDate: new Date(),
            currentDate: +new Date(),
            selectTypeOptions: [{
                text: '按日选择',
                value: 1
            },
                {
                    text: '按月选择',
                    value: 2
                },
            ],
            selectType: 1,
            page: 1,
            order: {
                order_amount: 0,
                order_count: 0,
            },
            isBottom:false
        }
    },
    mounted() {
        this.refresh();
        document.title = "车辆统计"
    },
    methods: {
        refresh(){

            this.getOrder();
        },
        showLoading(){
            this.loading = true;
        },
        closeLoading(){
            this.loading = false;
        },
        getOrder(){
            this.showLoading();
            var searchParams = {
                selectType: this.selectType,
                date: this.currentDate,
                page: 1,
                size: 30,
            };

            this.$http.get("/order/totalByBus?selectType=" + this.selectType + "&date=" + this.currentDate).then(res =>{
                this.order = res.data;
                this.closeLoading();
            });
        },
        onSelectTypeChange(value) {
            this.selectType = value;
            this.refresh();
        },
        onInput(event) {
            this.currentDate = +event;
            this.show = false;
            this.refresh();
        },
        formatDate: function(time){
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()


            return [year, month, day].map(formatNumber).join('/');
        },
        onClickLeft(){
            this.$router.back();
        },
        formatMonth: function (time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1

            return [year, month].map(formatNumber).join('/');

        }
    },
    computed:{
        formatedDate(){
            if(this.selectType == 1){
                return this.formatDate(this.currentDate);
            }

            return this.formatMonth(this.currentDate);
        }
    }
}
</script>

<style scoped>

.container{
    font-size: 14px;
    color: #666;
}

.header{
    color: #666;
    padding: 10px;
    background-color: #5CA3F6;
    color: #fff;
}
.selele-date{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #fff;
    padding: 10px;
}



.order-total{
    padding: 0px 10px;
    padding-top: 10px;
}
.order-total view{
    padding: 5px 0px;
    font-size: 16px;
}
.ico{
    width: 45px;
    height: 45px;
}
.order-list{
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
}
.order{
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}
.order-title{
    display: flex;
}
.order-title view{
    display: flex;
    flex-direction: column;
}
.order-amount{
    font-size: 18px;
    color:#FF6633;
}
.loading-container{
    padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/BusTotal.vue